import { render, staticRenderFns } from "./IndicatorFilter.vue?vue&type=template&id=2f24a1a2&scoped=true"
import script from "./IndicatorFilter.vue?vue&type=script&lang=js"
export * from "./IndicatorFilter.vue?vue&type=script&lang=js"
import style0 from "./IndicatorFilter.vue?vue&type=style&index=0&id=2f24a1a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f24a1a2",
  null
  
)

export default component.exports